import { View } from 'foundations-components/components/View';
import ApiError from '../Errors/ApiError';
import RecommendationsContainer from '../../containers/RecommendationsContainer';
import useWootricSurvey from '../../hooks/useWootricSurvey';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { InProgressSection } from '../../features/userProgress';
import AnnouncementsSection from '../../features/announcements/components/AnnouncementsSection';
import HomePageSection from './HomePageSection';
import { Flex } from 'foundations-components/components/Flex';
import GetStartedSearchPrompt from '../../features/search/components/GetStartedSearchPrompt';
import { FeaturedSection } from '../../features/internalContent/components/FeaturedSection';
import MostPopularCertificates from '../MostPopularCertificates/MostPopularCertificates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HomePageLayout = ({
  error,
  footerComponent
}) => {
  const {
    isMobile
  } = useMediaQuery();
  useWootricSurvey('CES');
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    children: error ?
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(HomePageSection, {
      children: /*#__PURE__*/_jsx(ApiError, {
        error: error,
        marker404: "HOMEPAGE_API_404",
        markerDefault: "HOMEPAGE_API_ERROR",
        resetLink: "/"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GetStartedSearchPrompt, {}), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: isMobile ? '500' : '1000',
        paddingBlock: isMobile ? '500' : '1000',
        children: [/*#__PURE__*/_jsx(FeaturedSection, {}), /*#__PURE__*/_jsx(AnnouncementsSection, {}), /*#__PURE__*/_jsx(InProgressSection, {}), /*#__PURE__*/_jsx(View, {
          "data-test-id": "pre-catalog-cards-container",
          children: /*#__PURE__*/_jsx(RecommendationsContainer, {})
        }), /*#__PURE__*/_jsx(MostPopularCertificates, {})]
      }), !error && footerComponent]
    })
  });
};
export default HomePageLayout;